export const translation = {
    common: {
        fields: {
            password: {
                label: 'Password',
                placeholder: 'Enter password',
                required: 'Please provide a password'
            },
            account: {
                label: 'Your Snowflake Account Name or URL',
                placeholder: 'https://account.us-east-2.aws.snowflakecomputing.com',
                required: 'Please provide a Snowflake URL',
                invalid: 'Please provide a valid Snowflake URL',
                datameerUrl: 'Please provide a Snowflake URL instead of a Datameer URL'
            },
            serviceAccountUser: {
                label: 'Snowflake user name',
                placeholder: 'Enter your Snowflake user name',
                required: 'Please provide a Snowflake user name'
            },
            properties: {
                label: 'Advanced Properties',
                validation: "Each line must consist of a single key-value association, separated by '='."
            },
            privateKey: {
                label: 'Private Key',
                required: 'Please provide a private key'
            }
        }
    }
};
